import { render, staticRenderFns } from "./VersionActivityNew.vue?vue&type=template&id=4df0b14f&scoped=true"
import script from "./VersionActivityNew.vue?vue&type=script&lang=js"
export * from "./VersionActivityNew.vue?vue&type=script&lang=js"
import style0 from "./VersionActivityNew.vue?vue&type=style&index=0&id=4df0b14f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df0b14f",
  null
  
)

export default component.exports